import { render, staticRenderFns } from "./ReceiptTypeTable.vue?vue&type=template&id=860713ea"
import script from "./ReceiptTypeTable.vue?vue&type=script&lang=js"
export * from "./ReceiptTypeTable.vue?vue&type=script&lang=js"
import style0 from "./ReceiptTypeTable.vue?vue&type=style&index=0&id=860713ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports